import React, { useState, useEffect } from 'react';
import { getAciGrid, getStandardColors, getGrayColors, aciToHex } from '../../../utils/aciColors';
import './ColorSelect.css';

const aciGrid = getAciGrid();
const standardColors = getStandardColors();
const grayColors = getGrayColors();

const ColorSelect = ({ isOpen, onClose, onSelect, initialAci = 7 }) => {
  const [selectedAci, setSelectedAci] = useState(initialAci);

  useEffect(() => {
    if (isOpen) setSelectedAci(initialAci);
  }, [isOpen, initialAci]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onSelect(selectedAci, aciToHex(selectedAci));
    onClose();
  };

  const selectedHex = aciToHex(selectedAci);

  return (
    <div className="cs-overlay" onClick={onClose}>
      <div className="cs-dialog" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="cs-header">
          <span className="cs-title">Renk Secimi</span>
          <button className="cs-close" onClick={onClose}>&times;</button>
        </div>

        <div className="cs-body">
          {/* ACI Grid */}
          <div className="cs-section-label">AutoCAD Color Index (ACI):</div>
          <div className="cs-grid">
            {aciGrid.map((row, ri) => (
              <div key={ri} className="cs-grid-row">
                {row.map((cell) => (
                  <div
                    key={cell.aci}
                    className={`cs-cell${selectedAci === cell.aci ? ' selected' : ''}`}
                    style={{ backgroundColor: cell.hex }}
                    title={`ACI ${cell.aci}`}
                    onClick={() => setSelectedAci(cell.aci)}
                  />
                ))}
              </div>
            ))}
          </div>

          {/* Standart renkler + Gri tonlari */}
          <div className="cs-bottom">
            <div className="cs-standard">
              {standardColors.map((c) => (
                <div
                  key={c.aci}
                  className={`cs-cell std${selectedAci === c.aci ? ' selected' : ''}`}
                  style={{ backgroundColor: c.hex }}
                  title={`ACI ${c.aci}`}
                  onClick={() => setSelectedAci(c.aci)}
                />
              ))}
            </div>
            <div className="cs-grays">
              {grayColors.map((c) => (
                <div
                  key={c.aci}
                  className={`cs-cell std${selectedAci === c.aci ? ' selected' : ''}`}
                  style={{ backgroundColor: c.hex }}
                  title={`ACI ${c.aci}`}
                  onClick={() => setSelectedAci(c.aci)}
                />
              ))}
            </div>
          </div>

          {/* Preview */}
          <div className="cs-preview-row">
            <div className="cs-preview-info">
              <span className="cs-preview-label">Renk:</span>
              <span className="cs-preview-value">ACI {selectedAci}</span>
            </div>
            <div className="cs-preview-swatch" style={{ backgroundColor: selectedHex }}>
              <span className="cs-preview-hex">{selectedHex}</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="cs-footer">
          <button className="cs-btn cs-btn-ok" onClick={handleConfirm}>Tamam</button>
          <button className="cs-btn cs-btn-cancel" onClick={onClose}>Iptal</button>
        </div>
      </div>
    </div>
  );
};

export default ColorSelect;
